module.exports = __webpack_public_path__ + "static/media/laptop_showcase_madrid.5cc0c0bf.png";